// extracted by mini-css-extract-plugin
export default {"fruitviewexample":"fruitviewexample_fed57fd9bc306249b5e2","steps":"steps_b9740b4fff05e2446b38"};